/**
 * For a given prompt, checks if one of its associated collections matches the given collection
 * @param {object} prompt
 * @param {object} collection
 * @returns {boolean}
 */

const promptMatchesCollection = (prompt, collection) => {
  return (
    prompt.collections &&
    prompt.collections.some((promptCollection) => {
      return promptCollection?.id?.toString() === collection.id?.toString();
    })
  );
};

export default promptMatchesCollection;
